import { useEffect, useState } from 'react';
import { Badge, Button, Dropdown } from 'antd';
import { ReactComponent as FilterSvg } from '../../../res/svg/filter.svg';
import { ReactComponent as Download } from '../../../res/svg/download.svg';
import DropDownFilters from '../../Molecules/DropDownFilters/DropDownFilters';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { getTasksExportExcel, setShowFiltrosTasks } from '../../../store/slice/taskSlice';
import './FilterButton.less';
/**
 * @component MapCurrentLine.tsx
 * @description FilterButton component to filter data and export to csv.
 * @return { Component }
 */
function FilterButton() {
  const dispatch = useAppDispatch();
  const [counterLength, setCounterLength] = useState(0);
  const showFiltros = useAppSelector(state => state.task.showFiltros);
  const filtros = useAppSelector(state => state.task.filtros);

  const handleVisibleChange = (flag: boolean) => {
    dispatch(setShowFiltrosTasks(flag))
  };

  const closeMenu = (isVisible: boolean) => {
    dispatch(setShowFiltrosTasks(isVisible))
  };

  useEffect(() => {

    let filterCount = 
    (filtros.ordenarPor !== undefined ? 1 : 0) +
    (filtros.fechaDesde !== undefined ? 1 : 0) +
    (filtros?.creadasPor?.length as number > 0 ? 1 : 0) +
    (filtros?.tipoTarea?.length as number > 0 ? 1 : 0);

    setCounterLength(filterCount);
  }, [filtros]);

  const exportExcel = () => {
    dispatch(getTasksExportExcel()).then((value: any)=>{
      const url = window.URL.createObjectURL(value.payload.data);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `tareas_${Date.now()}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
  }

  return (
    <div className="at-filter-button__container">
      <Badge count={counterLength} style={{ position: 'absolute', right: 25 }}>
        <Dropdown
          arrow={true}
          overlay={<DropDownFilters closeMenu={closeMenu} />}
          onVisibleChange={handleVisibleChange}
          visible={showFiltros}
          trigger={['click']}
        >
          <Button
            onClick={(e) => e.stopPropagation()}
            className="at-filter-button__circle"
            size="large"
            shape="circle"
            type={showFiltros ? 'primary' : 'ghost'}
            color={'daybreak-blue.600'}
            icon={<FilterSvg style={{ marginBottom: -2, color: showFiltros ? 'white' : '#006854' }} />}
          />
        </Dropdown>
      </Badge>
      <Button
        className="at-filter-button__button"
        size="large"
        shape="round"
        onClick={exportExcel}
        icon={<Download />}
        >
        Exportar vista
      </Button>
      
    </div>
  );
}

export default FilterButton;
